<template>
  <div class="content">
    <!--    banner_tip-->
    <div class="hotel-index__banner">
      <img src="https://dsimage.didatravel.com/v2-app/images/slogon_zh.svg" alt="">
    </div>
    <!--搜索栏-->
    <div>
      <searchBar @query="search"/>
    </div>
    <!--    点哪住哪-->
    <div class="map-click m-60">
      <div class="hotel-index-section__title" style="color: #fff">
        点那住那
      </div>

      <div class="fl" style="margin-top: 20px; gap: 20px">
        <div class="map">
          <c_map/>
        </div>
        <el-card>
          <div class="map-tip">
            <div class="tip-title">使用说明</div>
            <div class="tip-content">
              在地图上选择要居住的酒店位置，鼠标左键点击地图相应位置。
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!--    热门酒店-->
    <div class="hot_hotel m-60">
      <div class="hotel-index-section__title">
        酒店推荐
      </div>

      <el-skeleton style="margin-top: 22px;" :loading="hotCityLoading" animated>
        <template slot="template">
          <div style="display: flex">
            <div v-for="item in 3" style="flex: 1">
              <el-skeleton-item
                variant="image"
                style="width: 378px; height: 200px;"
              />
              <div style="padding: 14px;">
                <el-skeleton-item variant="h3" style="width: 50%;"/>
                <div
                  style="display: flex; align-items: center; margin-top: 16px; height: 16px;"
                >
                  <el-skeleton-item variant="text" style="margin-right: 16px;"/>
                  <el-skeleton-item variant="text" style="width: 30%;"/>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template>
          <el-carousel indicator-position="none" trigger="click">
            <el-carousel-item interval="9000" v-for="item in 3" :key="item">
              <div class="hot_hotel_list">
                <div class="hot_hotel_list_item" @click="toDetails(item)" v-for="item in hotHotel">
                  <img :src="item.hotel_image" alt="">
                  <div class="item_content">
                    <div class="title">{{ item.HotelName }}</div>
                    <div class="desc">
                      上榜目的地热销酒店精选
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </template>
      </el-skeleton>

    </div>

    <!--    轮播-->
    <div class="carousel m-60">
      <div class="hotel-index-section__title">
        大家都在看
      </div>

      <div style="margin-top: 25px">
        <el-carousel height="200px" direction="vertical" autoplay>
          <el-carousel-item v-for="img in banner" :key="img.id">
            <img class="banner_img"
                 :src="img.head_img"
                 alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!--    自营酒店-->

    <div class="hot_hotel m-60">
      <div style="display: flex;justify-content: space-between;align-items: center">
        <div class="hotel-index-section__title">
          自营酒店
        </div>
        <div @click="toMore">
          查看更多
        </div>
      </div>

      <el-skeleton style="margin-top: 22px;" :loading="selfHotelLoading" animated>
        <template slot="template">
          <div style="display: flex">
            <div v-for="item in 3" style="flex: 1">
              <el-skeleton-item
                variant="image"
                style="width: 378px; height: 200px;"
              />
              <div style="padding: 14px;">
                <el-skeleton-item variant="h3" style="width: 50%;"/>
                <div
                  style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px;"
                >
                  <el-skeleton-item variant="text" style="margin-right: 16px;"/>
                  <el-skeleton-item variant="text" style="width: 30%;"/>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template>
          <div>
            <div class="selfOperatedHotels">
              <div class="selfOperated-item" v-for="(item, index) in SelfHotel.data" @click="toDetails(item)"
                   :key="index">
                <img class="selfOperated-img"
                     :src="item.hotel_image"/>
                <div style="padding: 10px">
                  <div class="selfOperated-name">
                    {{ item.HotelName }}
                  </div>
                  <div class="selfOperated-address"><i class="el-icon-location-information"></i>
                    {{ item.address }}
                  </div>
                  <h2 class="selfOperated-price">
                    <span style="font-size: 16px;font-weight: normal;color: black">{{
                        item.LowestPrice.Currency
                      }}</span>{{ item.LowestPrice.Value }}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-skeleton>

    </div>


    <!--    热门城市-->
    <div class="hot_city m-60">
      <div class="fl">
        <span class="hotel-index-section__title">
          热门城市
        </span>
        <div class="city-list">
          <div class="city" @click="getHotCityHotels(item.city_code, index)"
               :class="index === active_city ? 'active_city': ''" v-for="(item, index) in cityList.popular_city"
               :key="index">
            {{ item.city_name_cn }}
          </div>
          <div class="city">
            <el-popover
              placement="bottom"
              width="450"
              trigger="click"
              v-model="visible">
              <div>
                <div class="citys">
                  <div class="city_item" v-for="item in cityList.city_list"
                       @click="getHotCityHotels(item.city_code, active_city)" :key="item.city_code">
                    {{ item.city_name_cn }}
                  </div>
                </div>
              </div>
              <div slot="reference">更多</div>
            </el-popover>
          </div>
        </div>
      </div>

      <el-skeleton style="width: 977px;margin-top: 22px;" :loading="cityHotelLoading" animated :count="3">
        <template slot="template">
          <div style="display: flex; gap: 10px;margin-top: 10px;">
            <el-skeleton-item
              variant="image"
              style="width: 200px; height: 200px;"
            />
            <div style="padding: 14px;">
              <el-skeleton-item variant="h3" style="width: 200px;"/>
              <div
                style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px;"
              >
                <el-skeleton-item variant="text" style="margin-right: 16px;"/>
                <el-skeleton-item variant="text" style="width: 600px;"/>
              </div>
            </div>
          </div>
        </template>
        <template>
          <div class="city_hotel">
            <div class="city_list">
              <div class="city_hotel_item" @click.stop="toDetails(item)" v-for="item in hotCityHotel" :key="item.id">
                <div class="hotel_img">
                  <el-image
                    style="width: 192px; height: 172px;"
                    :src="item.hotel_image"
                  >
                  </el-image>
                </div>
                <div class="hotel">
                  <div class="name">{{ item.HotelName }}</div>
                  <div class="info" v-html="item.blurb">

                  </div>
                </div>
                <div class="viewDetails">
                  <div class="price">￥ {{ item.LowestPrice.Value }}</div>
                  <div :class="item.status == 1 ? 'details' : 'noDetails'">查看详情</div>
                </div>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page.pageSize"
                :page-size="8"
                layout="total, prev, pager, next"
                :total="page.count">
              </el-pagination>

            </div>
            <div class="city_right">

              <!--              <c_map />-->
            </div>
          </div>
        </template>
      </el-skeleton>

    </div>
  </div>
</template>

<script>
import searchBar from "@/components/searchBar/index.vue";
import c_map from "@/components/nearby_map/index.vue";
import {banner, hotHotels, city_list, nowCityHotel, getCity, selfHotel} from "@/api/index";
import {mapState, mapMutations} from 'vuex';
import getLocation from '@/utils/getlocition';

export default {
  name: "index",
  components: {
    searchBar,
    c_map
  },
  data() {
    return {
      active: 0,
      active_city: 0,
      visible: false,
      hotHotel: [],
      cityList: {},
      hotCityHotel: [],
      banner: [],
      SelfHotel: [],
      cityHotelLoading: true,
      hotCityLoading: true,
      selfHotelLoading: false,
      position: {},
      page: {
        pageSize: 1,
        count: 0
      },
    }
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState(['in_out_date'])
  },
  methods: {
    ...mapMutations(['setDate']),
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.page.pageSize = val;
      this.getHotCityHotels(this.cityList.popular_city[this.active_city].city_code, this.active_city)
    },
    async getCity(position) {
      try {
        let {data, code, msg} = await getCity({
          longitude: position.lng,
          latitude: position.lat
        })
        if (code == 0) {
          this.position = data;
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getCurrentLocation() {
      try {
        const position = await getLocation();
        // 在这里可以使用获取到的经纬度信息进行后续操作
        await this.getCity(position);
      } catch (error) {
        console.error('获取定位失败', error);
      }
    },
    search() {
      if (this.$store.state.destination.type !== '' && this.$store.state.destination.type !== null && this.$store.state.destination.type !== undefined) {
        if (this.$store.state.destination.type == "hotel") {
          this.$router.push({
            name: 'details',
            params: {
              id: this.$store.state.destination.id
            }
          })
        } else if (this.$store.state.destination.type == 'city') {
          if (this.$router.history.current.path !== '/query') {
            this.$router.push({
              name: 'query',
            })
          }
        }
      } else {
        this.$message({
          message: '请输入选择目的地',
          icon: 'none'
        })
      }
    },
    toMore() {
      this.$router.push({
        name: 'selfHotel',
      })
    },
    toDetails(item) {
      if (item.status == 0) {
        return;
      }
      let id = item.HotelID;
      let hotelName = item.name;

      this.$router.push({
        name: 'details',
        params: {
          id,
          hotelName
        }
      })
    },
    // __________________________________________________________________________________________________________________
    init() {
      this.initDate();
      this.getBanner();
      this.getSelfHotel();
      // this.getCurrentLocation();
      this.getCityList();
      this.getHotHotels();
    },
    async getSelfHotel() {
      this.selfHotelLoading = true;
      try {
        let {data, code, msg} = await selfHotel();
        if (code == 0) {
          if (data.data.length <= 4) {
            this.SelfHotel = data;
          } else {
            data.data = data.data.slice(0, 4);
            this.SelfHotel = data;
          }

          this.selfHotelLoading = false;
        } else {
          this.$message({
            message: msg
          })
        }
      } catch (e) {
        console.log(e);
      }

    },
    async getBanner() {
      this.$loads.show();

      try {
        let {data, code, msg} = await banner();
        console.log(data, code, msg, 'banner')
        if (code == 0) {
          this.$loads.hidden();
          this.banner = data;

        } else {
          this.$loads.hidden();
          this.$message({
            message: msg,
            type: 'warning'
          })
        }
      } catch (e) {
        this.$loads.hidden();
      }
    },
    async getCityList() {
      try {
        let {data, code, msg} = await city_list();
        if (code == 0) {
          this.cityList = data;

          if (this.position.city_code) {
            this.cityList.popular_city.unshift({
              city_code: this.position.city_code,
              city_name_cn: this.position.city_name
            });
          }
          await this.getHotCityHotels(this.cityList.popular_city[0].city_code);

        } else {
          this.$message({
            message: msg,
            type: 'warning'
          })
        }
      } catch (e) {
      }
    },
    async getHotCityHotels(city_code, index = 0) {

      this.active_city = index;
      this.cityHotelLoading = true;
      this.visible = false;
      let startTime = this.in_out_date[0];
      let endTime = this.in_out_date[1];

      try {
        let {data, code, msg, count} = await nowCityHotel({
          city_code: city_code,
          check_in_date: startTime,
          check_out_date: endTime,
          page: this.page.pageSize
        });
        if (code === 0) {
          this.hotCityHotel = data;
          this.page.count = Number(count);
          this.cityHotelLoading = false;
        } else {
          this.cityHotelLoading = false;
          this.$message({
            message: msg,
            type: 'warning'
          })
        }

      } catch (e) {
        console.log(e);
      }
    },
    async getHotHotels() {
      this.hotCityLoading = true;

      try {
        let {data, code, msg} = await hotHotels({
          city_code: 1967,
          check_in_date: this.in_out_date[0],
          check_out_date: this.in_out_date[1]
        });
        if (code == 0) {
          this.hotCityLoading = false;
          this.hotHotel = data;
        } else {
          this.hotCityLoading = false;
          this.$message({
            message: msg,
            type: 'warning'
          })
        }
      } catch (e) {
        this.$loads.hidden();
        console.log(e);
      }
    },
    myformatDate(days = 0) {
      let num = 1000 * 60 * 60 * 24 * days;
      const date = new Date(Date.now() + num);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);

      return `${year}-${month}-${day}`;
    },
    // 初始化时间
    initDate() {
      let inDate = this.myformatDate();
      let outDate = this.myformatDate(1);
      let arr = [inDate, outDate]

      this.setDate(arr);
    }

  }
}
</script>

<style lang="scss" scoped>
.hotel-index__banner {
  display: flex;
  justify-content: center;

  > img {
    margin-top: 170px;
    margin-bottom: 90px;
  }
}

.hot_hotel {
  margin-top: 46px;

  .hot_hotel_list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 0 11px;
    gap: 22px;
    margin-top: 25px;

    .hot_hotel_list_item:hover {
      box-shadow: 3px 5px 18px 0 rgba(152, 158, 175, .32) !important;
    }

    .hot_hotel_list_item {
      height: 257px;
      background-color: #ffffff;
      border-radius: 12px;
      overflow: hidden;
      transition: box-shadow .3s;
      box-shadow: 0 2px 8px 0 rgba(152, 158, 175, .32);

      > img {
        width: 100%;
        height: 173px;
        object-fit: cover;
      }

      .item_content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #1f2b4b;
        padding: 16px 25px;

        .title {
          font-size: 19px;
          line-height: 24px;
          margin-bottom: 10px;
          font-weight: 700;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;

        }

        .desc {
          font-size: 12px;
        }
      }
    }
  }
}

.hotel-index-section__title {
  display: inline-block;
  font-size: 26px;
  line-height: 28px;
  margin-bottom: 0;
  white-space: nowrap;
  //mix-blend-mode: color-dodge;
}

.hotel-index-section__title:after {
  content: "";
  display: block;
  height: 2px;
  background-image: linear-gradient(90deg, #02d2a2, #070000);
  transform: translateY(6px);
}

.m-60 {
  margin-top: 60px;
}

.banner_img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.fl {
  display: flex;
  justify-content: space-between;

  > div {
    display: flex;
    gap: 8px;
    align-items: center;

    .city {
      padding: 5px 15px;
      border-radius: 4px;
    }
  }
}

.city:hover {
  background-color: #9ee5cd;
}

.active_city {
  background-color: #1DCD97 !important;
}

.city_hotel {
  display: flex;
  margin-top: 25px;

  .city_hotel_item {
    display: flex;
    padding: 16px;
    margin-bottom: 8px;
    background-color: #fff;
    box-sizing: border-box;
    box-shadow: 0 0 1px 1px #ccc;

    .hotel_img {
      margin-right: 16px;

      > img {
        width: 192px;
        height: 172px;
      }
    }

    .hotel {
      width: 500px;
      border-right: 1px solid #dadfe6;
      padding-right: 15px;

      .name {
        font-size: 18px;
        color: #0f294d;
        line-height: 24px;
        margin-bottom: 8px;
        cursor: pointer;
        font-weight: 600;
      }

      .info {
        color: #455873;
        line-height: 18px;
        font-size: 14px;
        max-height: 79px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
      }
    }

    .viewDetails {
      width: 230px;
      padding-left: 8px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;

      .price {
        color: #f32a4e;
        font-weight: 400;
        font-size: 16px;
        margin-bottom: 11px;
        margin-right: 10px;
      }

      .noDetails {
        color: #fff;
        border-color: #6ce3bf;
        background-color: rgb(148, 156, 154);
        box-shadow: 0 3px 8px 0 rgb(187, 192, 191);
        padding: 4.5px 19px;
        border-radius: 16px;
      }

      .details {
        color: #fff;
        border-color: #6ce3bf;
        background-color: #1DCD97;
        box-shadow: 0 3px 8px 0 #6ce3bf;
        padding: 4.5px 19px;
        border-radius: 16px;
      }
    }
  }
}

.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  text-align: right;
  font-weight: 700;
  margin: 20px 0;
}

.citys {
  max-height: 40vh;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 5px;
  overflow: auto;
  background-color: #fff;

  .city_item {
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
  }

  .city_item:hover {
    background-color: #d0cccc;
  }
}

.map-click {
  gap: 15px;

  .map-tip {
    display: flex;
    flex-direction: column;
    width: 300px;
    min-height: 300px;


    .tip-title {
      font-size: 22px;
      font-weight: 600;
      color: #000000;
      text-align: left;
      margin-bottom: 20px;
    }

    .tip-content {
      color: #000000;
      text-indent: 2rem;
    }
  }

  .map {
    flex: 1;
    min-height: 400px;
  }
}

.selfOperatedHotels {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.selfOperatedHotels {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  background-color: #fafafa;
  padding: 10px;

  .selfOperated-item {
    min-height: 200px;
    background-color: #fff;

    .selfOperated-img {
      width: 100%;
      height: 200px;
      object-fit: cover;
    }

    .selfOperated-name {
      overflow: hidden;
      margin: 10px;
      text-overflow: ellipsis;
    }

    .selfOperated-address {
      display: flex;
      align-items: center;
      gap: 10px;
      justify-content: flex-start;
      margin: 10px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin: 10px;

    }

    .selfOperated-price {
      display: flex;
      margin: 10px;
      gap: 10px;
      align-items: center;
      color: #f32a4e;
      font-size: 18px;
    }
  }
}
</style>
